import { Controller } from "@hotwired/stimulus"
import QRCode from "qrcode"

// Отображает QR-код из текстовой строки.
// Использование:
//   <canvas data-controller="qr-code" data-qr-code-text-value="<QR_STRING>"></canvas>
export default class extends Controller {
  static values = { text: String }

  connect() {
    this.render()
  }

  textValueChanged() {
    this.render()
  }

  render() {
    const text = this.textValue
    if (!text || text.length < 5) return

    QRCode.toCanvas(this.element, text, { width: 300, margin: 1, errorCorrectionLevel: "L" }, (error) => {
      if (error) {
        console.error("QR code render error:", error)
      }
    })
  }
}
